const state = {
  selected: 1,
  currentNav: 1,
  showSolution: false
}

const getters = {
  getSelected () {
    return state.selected
  },
  getNav () {
    return state.currentNav
  },
  getShowSolution () {
    return state.showSolution
  }
}

const mutations = {
  SET_SELECTED: (state, value) => {
    state.selected = value
  },
  SET_NAV: (state, value) => {
    state.currentNav = value
  },
  SET_SHOW_SOLUTION: (state, value) => {
    state.showSolution = value
  }
}

const actions = {
  setSelected ({ commit }, value) {
    commit('SET_SELECTED', value)
  },
  setNav ({ commit }, value) {
    commit('SET_NAV', value)
  },
  setShowSolution ({ commit }, value) {
    commit('SET_SHOW_SOLUTION', value)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
